import { css } from '@emotion/react';

const getTableRowCss = css`
  background: var(--cds-color-neutral-background-primary);

  &:hover {
    background: var(--cds-color-neutral-background-primary-weak);
  }
`;

export default getTableRowCss;
